import Froala from './Froala';

export default Froala;
